import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import DENTMedicalExaminationsAlert from './DENTMedicalExaminationsAlert';
import { Size } from '../../../../Enums/Size.enum';
import { UpcomingExaminationEvent } from '../../Interfaces/medicalExamination/UpcomingExaminationEvent.interface';

interface Props extends BaseModalProps {
	events: UpcomingExaminationEvent[];
}

const DENTMedicalExaminationsAlertModal = ({
	events,
	onClose,
	...baseModalProps
}: Props) => {
	return (
		<BaseModal
			{...baseModalProps}
			title={'patientTreatment.meddiDENT.dentalCross.upcomingExamination.title'}
			size={Size.LG}
			onClose={onClose}>
			<DENTMedicalExaminationsAlert events={events} onClose={onClose} />
		</BaseModal>
	);
};

export default DENTMedicalExaminationsAlertModal;
